<template>
  <div
    class="row top-organization"
  >
    <div class="col-md-4">
      <span
      >Оформлена: {{ applicant.name ? applicant.name : '&nbsp;' }}</span
      >
    </div>
    <div class="col-md-4">
      Email:
      <span
        v-html="
          applicant.email
            ? '<a href=' + 'mailto:' + applicant.email + '>' + applicant.email + '</a>'
            : '&nbsp;'
        "
      ></span>
    </div>
    <div class="col-md-4">
      Телефон:
      <span
        v-html="
          applicant.phone
            ? '<a href=' + 'tel:' + applicant.phone + '>' + applicant.phone + '</a>'
            : '&nbsp;'
        "
      ></span>
    </div>
  </div>
</template>

<script>
import applicationFormMixin from '../../mixins/applicationFormMixin'
import mainMixin from '../../mixins/mainMixin'

export default {
  name: 'ApplicantInfoBlock',
  mixins: [
    mainMixin,
    applicationFormMixin
  ],

  props: {
    applicant: {
      type: Object,
      default: () => ({
        email: null,
        id: null,
        info: null,
        name: null,
        organization_id: null,
        phone: null,
        role: null
      })
    }
  }
}
</script>
